import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { useSalonStore } from "@/lib/store/salon";

import { GET_DISCOUNT_COHORT_MATRICES } from "../graphql/cohort-matrices-queries";

export function useDiscountCohortMatrices() {
  const currentFranchise = useSalonStore((state) => state.getCurrentFranchise());
  const franchiseId = currentFranchise?.franchiseId ?? "";

  // Send the year as an integer — the backend builds Jan 1 → Dec 31
  // boundaries in the salon's timezone. We deliberately avoid sending
  // local-browser Date objects because their ISO string would be the
  // previous-year-Dec-31 in UTC for timezones east of UTC.
  const acquisitionYear = useMemo(() => new Date().getFullYear(), []);

  const { data, loading, error, refetch } = useQuery(GET_DISCOUNT_COHORT_MATRICES, {
    variables: {
      franchiseId,
      acquisitionYear,
    },
    skip: !franchiseId,
  });

  return {
    data: data?.discountCohortMatrices ?? null,
    loading,
    error,
    refetch,
  };
}
